function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg1964(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "100%",
    width: "100%",
    viewBox: "0 0 700 700",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    key: 0,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 22.17,
    height: 8.86,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 1.1075
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 11.085,
    y: 4.43
  }, "\n        Hamilton\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 1,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 8.86,
    width: 22.17,
    height: 22.41,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 2.77125
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 11.085,
    y: 20.064999999999998
  }, "\n        Schuyler\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 2,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 31.27,
    width: 22.17,
    height: 26.72,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.434
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 11.085,
    y: 44.629999999999995
  }, "\n        Yates\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 3,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 57.99,
    width: 22.17,
    height: 30.16,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.434
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 11.085,
    y: 73.07000000000001
  }, "\n        Lewis\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 4,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 88.15,
    width: 22.17,
    height: 35.12,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 2.4633333333333334
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 11.085,
    y: 105.71000000000001
  }, "\n        Schoharie\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 5,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 123.27,
    width: 22.17,
    height: 41.32,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.6950000000000003
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 11.085,
    y: 143.93
  }, "\n        Seneca\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 6,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 164.59,
    width: 22.17,
    height: 45.95,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 3.1671428571428573
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 11.085,
    y: 187.565
  }, "\n        Orleans\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 7,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 210.54,
    width: 22.17,
    height: 46.21,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 3.1671428571428573
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 11.085,
    y: 233.64499999999998
  }, "\n        Wyoming\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 8,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 256.75,
    width: 22.17,
    height: 51.16,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.434
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 11.085,
    y: 282.33
  }, "\n        Essex\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 9,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 307.9,
    width: 22.17,
    height: 53.27,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 2.77125
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 11.085,
    y: 334.53499999999997
  }, "\n        Cortland\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 10,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 361.17,
    width: 22.17,
    height: 53.45,
    style: {
      fill: "#1666CB"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 2.77125
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 11.085,
    y: 387.89500000000004
  }, "\n        Franklin\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 11,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 414.63,
    width: 22.17,
    height: 54.19,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.434
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 11.085,
    y: 441.725
  }, "\n        Tioga\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 12,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 468.81,
    width: 22.17,
    height: 55.2,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 3.6950000000000003
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 11.085,
    y: 496.41
  }, "\n        Greene\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 13,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 524.01,
    width: 22.17,
    height: 55.64,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 2.77125
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 11.085,
    y: 551.83
  }, "\n        Allegany\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 14,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 579.65,
    width: 22.17,
    height: 58.46,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 2.77125
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 11.085,
    y: 608.88
  }, "\n        Chenango\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 15,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 638.11,
    width: 22.17,
    height: 61.89,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 2.77125
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 11.085,
    y: 669.0550000000001
  }, "\n        Delaware\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 16,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 22.17,
    y: 0,
    width: 35.34,
    height: 39.89,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.5340000000000003
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 39.84,
    y: 19.945
  }, "\n        Livingston\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 17,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 57.51,
    y: 0,
    width: 35.34,
    height: 39.89,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.890000000000001
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 75.18,
    y: 19.945
  }, "\n        Warren\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 18,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 92.85,
    y: 0,
    width: 37.5,
    height: 39.89,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.25
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 111.6,
    y: 19.945
  }, "\n        Putnam\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 19,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 130.35,
    y: 0,
    width: 37.7,
    height: 39.89,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 3.7700000000000005
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 149.2,
    y: 19.945
  }, "\n        Washington\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 20,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 168.05,
    y: 0,
    width: 39.67,
    height: 39.89,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.611666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 187.88500000000002,
    y: 19.945
  }, "\n        Fulton\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 21,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 207.72,
    y: 0,
    width: 39.73,
    height: 39.89,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.675714285714285
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 227.585,
    y: 19.945
  }, "\n        Madison\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 22,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 247.45,
    y: 0,
    width: 40.38,
    height: 39.89,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.98625
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 267.64,
    y: 19.945
  }, "\n        Columbia\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 23,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 287.83,
    y: 0,
    width: 40.86,
    height: 39.89,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.698571428571428
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 308.26,
    y: 19.945
  }, "\n        Genesee\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 24,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 328.69,
    y: 0,
    width: 40.89,
    height: 39.89,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.648333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 349.135,
    y: 19.945
  }, "\n        Otsego\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 25,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 369.59,
    y: 0,
    width: 41.98,
    height: 39.89,
    style: {
      fill: "#0645B4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.698571428571428
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 390.58,
    y: 19.945
  }, "\n        Clinton\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 26,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 411.57,
    y: 0,
    width: 42.46,
    height: 39.89,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.98625
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 432.8,
    y: 19.945
  }, "\n        Sullivan\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 27,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 454.03,
    y: 0,
    width: 43.2,
    height: 39.89,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.98625
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 475.63,
    y: 19.945
  }, "\n        Tompkins\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 28,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 497.23,
    y: 0,
    width: 47.75,
    height: 39.89,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.989
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 521.105,
    y: 19.945
  }, "\n        Montgomery\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 29,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 544.98,
    y: 0,
    width: 50.29,
    height: 39.89,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 7.978
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 570.125,
    y: 19.945
  }, "\n        Wayne\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 30,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 595.27,
    y: 0,
    width: 51.96,
    height: 39.89,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.98625
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 621.25,
    y: 19.945
  }, "\n        Herkimer\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 31,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 647.24,
    y: 0,
    width: 52.76,
    height: 39.89,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.698571428571428
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 673.62,
    y: 19.945
  }, "\n        Ontario\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 32,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 22.17,
    y: 39.89,
    width: 59.38,
    height: 37.92,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.4472727272727273
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 51.86,
    y: 58.85
  }, "\n        Cattaraugus\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 33,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 22.17,
    y: 77.81,
    width: 59.38,
    height: 40.95,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.825
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 51.86,
    y: 98.285
  }, "\n        Cayuga\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 34,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 22.17,
    y: 118.77,
    width: 59.38,
    height: 41.35,
    style: {
      fill: "#1666CB"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.594444444444445
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 51.86,
    y: 139.445
  }, "\n        Jefferson\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 35,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 22.17,
    y: 160.12,
    width: 59.38,
    height: 42.86,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.1433333333333335
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 51.86,
    y: 181.55
  }, "\n        Oswego\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 36,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 22.17,
    y: 202.98,
    width: 59.38,
    height: 46.8,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.685714285714285
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 51.86,
    y: 226.38
  }, "\n        Steuben\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 37,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 22.17,
    y: 249.79,
    width: 59.38,
    height: 47.3,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.757142857142857
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 51.86,
    y: 273.44
  }, "\n        Chemung\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 38,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 22.17,
    y: 297.09,
    width: 59.38,
    height: 47.58,
    style: {
      fill: "#1666CB"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.965
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 51.86,
    y: 320.88
  }, "\n        St._Lawrence\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 39,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 22.17,
    y: 344.67,
    width: 59.38,
    height: 49.18,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.1475
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 51.86,
    y: 369.26
  }, "\n        Saratoga\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 40,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 22.17,
    y: 393.85,
    width: 59.38,
    height: 68.31,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 9.896666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 51.86,
    y: 428.005
  }, "\n        Ulster\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 41,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 22.17,
    y: 462.16,
    width: 59.38,
    height: 71.45,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.938000000000001
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 51.86,
    y: 497.88500000000005
  }, "\n        Chautauqua\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 42,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 22.17,
    y: 533.61,
    width: 59.38,
    height: 82.97,
    style: {
      fill: "#1666CB"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.938000000000001
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 51.86,
    y: 575.095
  }, "\n        Rensselaer\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 43,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 22.17,
    y: 616.59,
    width: 59.38,
    height: 83.41,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 7.4225
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 51.86,
    y: 658.2950000000001
  }, "\n        Rockland\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 44,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 81.55,
    y: 39.89,
    width: 59.02,
    height: 85.45,
    style: {
      fill: "#1666CB"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.365454545454546
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 111.06,
    y: 82.61500000000001
  }, "\n        Schenectady\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 45,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 140.57,
    y: 39.89,
    width: 63.16,
    height: 85.45,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 10.526666666666666
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 172.14999999999998,
    y: 82.61500000000001
  }, "\n        Orange\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 46,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 203.73,
    y: 39.89,
    width: 63.8,
    height: 85.45,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 7.975
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 235.63,
    y: 82.61500000000001
  }, "\n        Dutchess\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 47,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 267.53,
    y: 39.89,
    width: 72.93,
    height: 85.45,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 12.155000000000001
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 303.995,
    y: 82.61500000000001
  }, "\n        Broome\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 48,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 340.46,
    y: 39.89,
    width: 74.38,
    height: 85.45,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 9.2975
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 377.65,
    y: 82.61500000000001
  }, "\n        Richmond\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 49,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 414.84,
    y: 39.89,
    width: 76.81,
    height: 85.45,
    style: {
      fill: "#1666CB"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 10.972857142857142
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 453.245,
    y: 82.61500000000001
  }, "\n        Niagara\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 50,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 491.65,
    y: 39.89,
    width: 90.59,
    height: 85.45,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 14.241666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 536.9449999999999,
    y: 82.61500000000001
  }, "\n        Oneida\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 51,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 582.24,
    y: 39.89,
    width: 117.76,
    height: 85.45,
    style: {
      fill: "#0645B4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 14.241666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 641.12,
    y: 82.61500000000001
  }, "\n        Albany\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 52,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 81.55,
    y: 125.34,
    width: 142.33,
    height: 92.25,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 11.53125
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 152.715,
    y: 171.465
  }, "\n        Onondaga\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 53,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 81.55,
    y: 217.59,
    width: 142.33,
    height: 137.2,
    style: {
      fill: "#1666CB"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 22.866666666666664
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 152.715,
    y: 286.19
  }, "\n        Monroe\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 54,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 81.55,
    y: 354.79,
    width: 142.33,
    height: 156.3,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 20.332857142857144
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 152.715,
    y: 432.94000000000005
  }, "\n        Suffolk\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 55,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 81.55,
    y: 511.08,
    width: 142.33,
    height: 188.92,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 12.93909090909091
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 152.715,
    y: 605.54
  }, "\n        Westchester\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 56,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 223.88,
    y: 125.34,
    width: 137.17,
    height: 235.08,
    style: {
      fill: "#1666CB"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 34.2925
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 292.465,
    y: 242.88
  }, "\n        Erie\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 57,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 361.05,
    y: 125.34,
    width: 156.95,
    height: 235.08,
    style: {
      fill: "#1666CB"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 31.389999999999997
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 439.525,
    y: 242.88
  }, "\n        Bronx\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 58,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 518,
    y: 125.34,
    width: 182,
    height: 235.08,
    style: {
      fill: "#002B84"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 22.75
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 609,
    y: 242.88
  }, "\n        New_York\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 59,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 223.88,
    y: 360.43,
    width: 291.77,
    height: 148.14,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 24.689999999999998
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 369.765,
    y: 434.5
  }, "\n        Nassau\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 60,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 223.88,
    y: 508.57,
    width: 291.77,
    height: 191.43,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 31.905
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 369.765,
    y: 604.285
  }, "\n        Queens\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 61,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 515.65,
    y: 360.43,
    width: 184.35,
    height: 339.57,
    style: {
      fill: "#1666CB"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 36.87
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 607.8249999999999,
    y: 530.215
  }, "\n        Kings\n      ")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg1964);
export default __webpack_public_path__ + "static/media/1964.8180f4afbb1fb15329fceb39be063475.svg";
export { ForwardRef as ReactComponent };